import menuOptions from './menu-options.js'
import nativeState from './native-state.js'

function labelIdentity (accessor, d) {
  return d[accessor]
}

var id = (function () {
  var _id = 0
  return function () {
    return 'rich-select-' + _id++
  }
})()

export default function (data, node, opts, i) {
  var ns = nativeState(node)

  opts = opts || {}
  opts.render = opts.render || {}
  opts.setDefaultOption = typeof opts.setDefaultOption === 'undefined' ? true : opts.setDefaultOption
  data.accessors = opts.accessors || {}
  data.attachToWrapper = opts.attachToWrapper || false

  if (!data.id) {
    data.id = id()
  }

  // By default the rich select mocks a native select. This allows us to set
  // the value on the native select and the rich updates. However, it can
  // be extra expensive to build thousands of native `option` elements. Setting
  // `nativeSupport` to false results in faster rich selects, but we lose
  // the ability to set the value on the native select. Use only when there are thousand of options
  data.nativeSupport = typeof opts.nativeSupport !== 'undefined' ? opts.nativeSupport: true

  // Max rows we'll show on filtering selects. See #357
  data.maxFilteringResults = opts.maxFilteringResults || Number.POSITIVE_INFINITY // By default it's unlimited

  data.autofocus = i === 0 && opts.autofocus || false
  data.filter = opts.filter
  data.changeableTags = opts.changeableTags
  data.onSearch = opts.onSearch
  data.disableKeyboardControl = typeof opts.disableKeyboardControl !== 'undefined' ? opts.disableKeyboardControl : false
  data.placeholder = opts.placeholder
  data.fullHeight = opts.fullHeight
  data.forceMenuBelow = typeof opts.forceMenuBelow !== 'undefined' ? opts.forceMenuBelow : false // Prevent "smart" positioning of menu and force the menu to always appear below the control
  data.accessors.label = data.accessors.label || 'label'
  data.accessors.value = data.accessors.value || 'value'
  data.closeOnClick = typeof opts.closeOnClick !== 'undefined' ? !!data.closeOnClick : true
  data.splitOn = opts.splitOn || /[\n\r]/g // Split on newlines by default
  data.disabled = opts.disabled || ns.disabled
  data.mapOnSelect = opts.mapOnSelect || function (item) { return item } // Allows someone to mutate an item before it's selected (For SB3 #16536)
  data.hideSelectedOptions = opts.hideSelectedOptions || false // Rather than showing selected options, hide them. Applies to the dropdown options and the select control items
  data.stayOpenOnSelect = opts.stayOpenOnSelect || false // Keeps the rich select open after selecting an option

  data.render = {
    create: opts.render.create || labelIdentity.bind(null, data.accessors.label),
    groupHeader: opts.render.groupHeader,
    item: opts.render.item || labelIdentity.bind(null, data.accessors.label),
    itemRemove: opts.render.itemRemove,
    itemBefore: opts.render.itemBefore,
    itemAfter: opts.render.itemAfter,
    option: opts.render.option,
    resultset: opts.render.resultset
  }

  data.multiple = opts.multiple || ns.multiple
  if (opts.combo) {
    // Force multiple to false if it's a combo select. It doesn't make sense, and it
    // allows transition from multiple to combo
    data.multiple = false
  }
  data.filterSuggestion = opts.filterSuggestion
  data.combo = opts.combo

  data.creatable = opts.creatable || function () { return false }
  if (data.creatable) {
    data.creatable = typeof data.creatable === 'function' ? data.creatable
                                                          : function (d) { return true }
  }
  data.groupBy = opts.groupBy
  data._options = opts.options // Original options passed in
  data.onCreate = opts.onCreate || Function.prototype
  data.filterable = !!(data.onSearch || data.filter || data.combo)

  if (opts.setDefaultOption && data._options && !data.multiple && !data.filterable) {
    // If we receive the options array (meaning we aren't parsing a native control)
    // Then we want to make sure there is a selected option
    var selected = data._options.filter(function (o) {
                                  return o.selected
                                })

    if (!selected.length && data._options.length) {
      data._options[0].selected = true
    }
  }
  // Set the menu options
  data.menuOptions = menuOptions(data, node, true)

  return data
}
